import styled from 'styled-components';

export const GradientContainer = styled.div`
  flex: 1;
  background: linear-gradient(
    to right,
    ${({ primary }) => primary} 0% 60%,
    ${({ secondary }) => secondary} 60% 85%,
    ${({ tertiary }) => tertiary} 85% 100%
  );
  display: flex;
  justify-content: center;
  align-items: flex-end;

  @media (max-width: 768px) {
    background: linear-gradient(
      to bottom,
      ${({ primary }) => primary} 0% 70%,
      ${({ secondary }) => secondary} 70% 85%,
      ${({ tertiary }) => tertiary} 85% 100%
    );
    align-items: flex-end;
  }
`;

export const Wrapper = styled.div`
  max-width: 1120px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: stretch;
  padding: 0 1em;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
    padding: 1.5em 1em 0;
  }
`;

export const InnerContent = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;

  @media (max-width: 768px) {
    align-items: center;
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.4em;
  padding: 0 0 1.5em 0.5em;
  flex: 1;
  min-width: 0;
  justify-content: center;

  @media (max-width: 768px) {
    padding: 0 0 1em;
    align-items: center;
    text-align: left;
    justify-content: flex-start;
  }
`;

export const ContentTitle = styled.div`
  display: flex;
  gap: 1em;
  align-items: center;
  height: 120px;

  img {
    transform: scale(0.6);
    flex-shrink: 0;
  }

  @media (max-width: 425px) {
    justify-content: center;
    img {
      display: none;
    }
    p {
      font-size: 36px;
    }
  }
`;

export const Title = styled.p`
  font-family: 'Inter', sans-serif;
  color: #fff;
  font-size: 2.5em;
  font-style: normal;
  font-weight: 200;
  line-height: 48px;

  @media (max-width: 375px) {
    font-size: 2em;
    line-height: 38px;
  }
`;

export const ContentDescription = styled.div`
  display: grid;
  gap: 0.5em;
`;

export const Description = styled.p`
  font-family: 'Inter', sans-serif;
  color: #fff;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
`;

export const ContentButton = styled.div`
  display: flex;
  align-items: center;
  gap: 1em;
  margin-top: 0.5em;

  @media (max-width: 425px) {
    justify-content: center;
  }
`;

export const ContentHero = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-end;
  flex-shrink: 0;
  max-width: 55%;

  img {
    width: 100%;
    max-height: 80vh;
    object-fit: contain;
    display: block;
  }

  @media (max-width: 768px) {
    max-width: 65%;
    margin-bottom: 0;
    padding-bottom: 0;

    img {
      max-height: 40vh;
    }
  }

  @media (max-width: 425px) {
    max-width: 75%;

    img {
      max-height: 35vh;
    }
  }
`;
